import { useTranslations } from "next-intl";
import Image from "next/image";
import Link from "next/link";

export function Logo() {
  const t = useTranslations("Logo");

  return (
    <Link href="/" className="flex items-center gap-3">
      <Image
        alt={t("alt")}
        src="/logo.svg"
        unoptimized
        width={64}
        height={64}
        className="h-9 w-auto sm:h-7"
      />
      <span className="hidden text-xl font-extrabold text-rose-700 sm:inline sm:text-2xl dark:text-rose-400">
        LiveMonetize
      </span>
    </Link>
  );
}
